import { VacancyProps } from "storyblok/components";

import { VacancyCard } from "components/vacancies";

import { getEducationCode } from "helpers/hooks/getEducationCode";

export function generateVacancyOverviewCard(
    v: VacancyProps,
    zzp: boolean,
    departmentSalaries: Record<string, string>
) {
    if (!v) return <></>;

    const href = zzp
        ? `/zorgprofessionals/opdrachten/${String(v?.id)}`
        : `/zorgprofessionals/vacatures/${v?.slug ?? ""}`;
    const category = zzp ? v?.start_date : v?.department;
    const hours = zzp
        ? v?.uren_per_week
        : v?.min_hours && v?.max_hours
        ? `${v.min_hours}-${v.max_hours} uur`
        : null;
    const city = zzp ? v?.client?.town : v.city;
    const education = zzp ? v?.niveau : v?.education_code;
    const salary: string = departmentSalaries[`${v?.department as string}`]
        ? departmentSalaries[`${v?.department as string}`]
        : departmentSalaries.Standaard;

    return (
        <VacancyCard
            overview
            key={JSON.stringify(v.slug) + JSON.stringify(v.title)}
            title={v.title}
            href={href}
            category={category}
            hours={hours}
            education={getEducationCode(education)}
            region={city ? `Regio ${city}` : ""}
            salary={salary}
        />
    );
}
